import React from 'react';
import { cn } from '../../lib/utils';

/**
 * StatsGrid — responsive wrapper around KPI cards.
 * Defaults to 4-column grid on xl, collapsing gracefully.
 *
 * Props:
 *   cols — 2 | 3 | 4 | 5 (xl breakpoint)
 */
const COL_MAP = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4',
  5: 'sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
};

const StatsGrid = ({ cols = 4, className = '', children }) => (
  <div className={cn('grid grid-cols-1 gap-4 mb-6', COL_MAP[cols] || COL_MAP[4], className)}>
    {children}
  </div>
);

export default StatsGrid;
